export default "__VITE_ASSET__ZEW$sXW0__"